module.exports = __webpack_public_path__ + "img/20250411_AAAI.0863fffc.jpg";